import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export enum DhiraaguEventTypes {
    "enquiry" = "11c3861d-f728-48a3-82b7-f2d0a5bf0d70",
    "call" = "0c032d95-9e1d-40a6-b2d3-bcb5c78cd5f9",
    "sale" = "5c92ce5b-72f3-4aef-b605-ddfaad51d0d3",
    // "demo" = "72ce0316-3da1-4797-b594-785615357aed",
    // "booking" = "7dfe3cff-decc-4af1-a8f1-864b44b98bbd",
    // "walkin" = "a3bdf0ef-3d25-4af3-9c09-6a3a9c9a504c",
}

export enum EventCallType {
    "inbound" = "8e08e7ce-38a5-44c3-8904-8a723d4c2046",
    "outBound" = "1e6981ae-4049-4e4e-aab9-f4c31200a102",
}

export const DHIRAAGU__EVENT__ENQUIRY__CUSTOMER_NAME__COLUMN_ID = "bf589ec5-afe4-490e-825c-38ac1e40b732" as Uuid;

export const DHIRAAGU__EVENT__ENQUIRY__CONTACT_NUMBER__COLUMN_ID = "665338fc-e5e4-48b9-b6ae-b3eafd068c4b" as Uuid;

export const DHIRAAGU__EVENT__ENQUIRY__DIGITAL_LEAD_STATUS__COLUMN_ID = "a37686c8-032b-41d6-af2c-410ba6a054d9" as Uuid;

export const DHIRAAGU__EVENT__ENQUIRY__ISLAND__COLUMN_ID = "348e9210-3c0f-473e-990e-53be0e9d2042" as Uuid;

export const DHIRAAGU__EVENT__ENQUIRY__ATOLL__COLUMN_ID = "2c80d6af-a61f-4768-906a-8dcfc16e04b8" as Uuid;

export const DHIRAAGU__EVENT__ENQUIRY__REGION__COLUMN_ID = "f1f0c99f-694e-44e9-a9f8-67f6eed18db4" as Uuid;

export const DHIRAAGU__EVENT__ENQUIRY__ROCS__COLUMN_ID = "63555623-470b-47a0-92e8-b311e498de86" as Uuid;

export const DHIRAAGU__EVENT__ENQUIRY__GENDER__COLUMN_ID = "082783f0-d18f-4339-9a6e-c7be7d88d371" as Uuid;

export const DHIRAAGU__EVENT__ENQUIRY__HOUSE_NUMBER__COLUMN_ID = "1fdbeb0d-3a94-46ed-9df5-e56e6bf0016d" as Uuid;

export const DHIRAAGU__EVENT__ENQUIRY__AREA__COLUMN_ID = "8ab64b87-ae70-41ad-aebd-41f4ec9c2163" as Uuid;

export const DHIRAAGU__EVENT__ENQUIRY__LANDMARK__COLUMN_ID = "c5b17882-5192-43cf-bb7e-c25dd9eb48f2" as Uuid;

export const DHIRAAGU__EVENT__ENQUIRY__UTM_PLATFORM__COLUMN_ID = "6497e672-6106-4d04-b574-d3c9b1760970" as Uuid;

export const DHIRAAGU__EVENT__ENQUIRY__UTM_SOURCE__COLUMN_ID = "202fbb33-7289-4e49-80ce-6668409f41d2" as Uuid;

export const DHIRAAGU__EVENT__ENQUIRY__UTM_MEDIUM__COLUMN_ID = "8f027748-9966-402c-85ca-ca958b306643" as Uuid;

export const DHIRAAGU__EVENT__ENQUIRY__UTM_CAMPAIGN__COLUMN_ID = "0a83349e-4e25-451c-a5bb-3d96ab080a5b" as Uuid;

export const DHIRAAGU__EVENT__ENQUIRY__UTM_TERM__COLUMN_ID = "ffffb282-b61d-4d21-aab5-51c8e30e99d6" as Uuid;

export const DHIRAAGU__EVENT__ENQUIRY__UTM_CONTENT__COLUMN_ID = "4efd7533-2495-496b-b2ec-835b7271be10" as Uuid;

export const DHIRAAGU__EVENT__ENQUIRY__ASSOCIATED_BEAT__COLUMN_ID = "f4b16242-6563-431b-b43d-ed009d95f084" as Uuid;

export const DHIRAAGU__EVENT__CALLS__CALL_TYPE__COLUMN_ID = "4aad9f9a-3347-4d5a-adb0-0a1365fbbef1" as Uuid;

export const DHIRAAGU__EVENT__CALLS__STATUS__COLUMN_ID = "9a627c5f-1923-4b84-adce-821aa926b99c" as Uuid;

export const DHIRAAGU__EVENT__CALLS__CALL_DISPOSITION__COLUMN_ID = "4b0f469e-9aeb-4983-ad57-921ec2aaf7d7" as Uuid;

export const DHIRAAGU__EVENT__CALLS__LOGGED_CALL_REMARKS__COLUMN_ID = "5388e0ba-3446-40bb-8e5f-4da2b2365a77" as Uuid;

export const DHIRAAGU__EVENT__CALLS__CALL_START_TIME__COLUMN_ID = "e4cbe18c-fdb2-46a3-8536-023cee4652da" as Uuid;

export const DHIRAAGU__EVENT__CALLS__CALL_END_TIME__COLUMN_ID = "0e51074b-6d16-4ed5-bf97-1c12f2bb6b89" as Uuid;

export const DHIRAAGU__EVENT__CALLS__CALL_DURATION__COLUMN_ID = "cf5fbf11-f9a7-4c9f-87b5-5106d072632c" as Uuid;

export const DHIRAAGU__EVENT__CALLS__SCHEDULED_BY__COLUMN_ID = "c3d6b871-62a4-4fa6-aab9-d3e045bd3357" as Uuid;

export const DHIRAAGU__EVENT__CALLS__SCHEDULED_ON__COLUMN_ID = "ab808708-4b16-4b8d-a096-da42c7aef64c" as Uuid;

export const DHIRAAGU__EVENT__CALLS__LOGGED_BY__COLUMN_ID = "f4de126a-e12f-4424-af3b-5484775fc1dd" as Uuid;

export const DHIRAAGU__EVENT__CALLS__LOGGED_ON__COLUMN_ID = "10ccdd8a-3547-410c-a209-9a4491b152d3" as Uuid;

export const DHIRAAGU__EVENT__CALLS__CANCELLED_BY__COLUMN_ID = "568154bb-5e2a-45fc-8780-e35a17dafac2" as Uuid;

export const DHIRAAGU__EVENT__CALLS__CANCELLED_ON__COLUMN_ID = "caf6d6a3-70c2-4805-ad2f-14e893813df4" as Uuid;

export const DHIRAAGU__EVENT__CALLS__CANCELLATION_REMARKS__COLUMN_ID = "72149935-4fc7-4ac5-8da2-0800e1897d3a" as Uuid;

export const DHIRAAGU__EVENT__CALLS__UTM_PLATFORM__COLUMN_ID = "465ef256-97f4-46d4-9740-13221501144c" as Uuid;

export const DHIRAAGU__EVENT__CALLS__UTM_SOURCE__COLUMN_ID = "0099316d-f043-4d0a-ab1d-485e8ddb9591" as Uuid;

export const DHIRAAGU__EVENT__CALLS__UTM_MEDIUM__COLUMN_ID = "ccf86dfd-0ff1-44e4-9b9c-200082fd79ad" as Uuid;

export const DHIRAAGU__EVENT__CALLS__UTM_CAMPAIGN__COLUMN_ID = "243fd099-ffea-43cf-a5ad-6621774f06b1" as Uuid;

export const DHIRAAGU__EVENT__CALLS__UTM_TERM__COLUMN_ID = "0755b38b-6a21-418b-acfa-7ff41fbc625f" as Uuid;

export const DHIRAAGU__EVENT__CALLS__UTM_CONTENT__COLUMN_ID = "cded00c9-0c3a-4024-8bd8-787fd2572be4" as Uuid;

export const DHIRAAGU__EVENT__CALLS__ASSOCIATED_BEAT__COLUMN_ID = "9e100f62-12f8-4160-9ff0-fb8f4871f800" as Uuid;

export const DHIRAAGU__EVENT__SALES__STATUS__COLUMN_ID = "c8921915-ecd2-4d02-9e61-55200785572f" as Uuid;

export const DHIRAAGU__EVENT__SALES__ACCOUNT_NUMBER__COLUMN_ID = "5de1d1ad-a702-4ec9-8a1a-07ec04eb2285" as Uuid;

export const DHIRAAGU__EVENT__SALES__ASSOCIATED_BEAT__COLUMN_ID = "9421d65a-7311-4f51-bde6-8911fe90d3a9" as Uuid;

export const DHIRAAGU__EVENT__SALES__UTM_PLATFORM__COLUMN_ID = "b3bb187d-7796-4938-bd7d-466ee464a92c" as Uuid;

export const DHIRAAGU__EVENT__SALES__UTM_SOURCE__COLUMN_ID = "116ed9a0-55fa-4916-a605-1923d04de9bb" as Uuid;

export const DHIRAAGU__EVENT__SALES__UTM_MEDIUM__COLUMN_ID = "c6e7f14d-9019-4bd4-9638-e51b71f785b1" as Uuid;

export const DHIRAAGU__EVENT__SALES__UTM_CAMPAIGN__COLUMN_ID = "0e56b4a0-8cff-4823-9a2e-a2e943e55ac6" as Uuid;

export const DHIRAAGU__EVENT__SALES__UTM_TERM__COLUMN_ID = "ff84fc3c-d11a-498f-9e41-e78d0ef182ba" as Uuid;

export const DHIRAAGU__EVENT__SALES__UTM_CONTENT__COLUMN_ID = "39ad13d4-9996-4dc6-b2d1-40be59f73c20" as Uuid;

export enum EnquiryStatusEnum {
    NEW = "484a9532-7704-42cc-ac3a-ef6657cc7db3",
    DUPLICATE = "044a9c2a-605a-46dc-8738-7775194d56cc",
    RETURN = "3434e029-78c0-4028-b22d-a728058d42c3",
    ARCHIVE = "dc4045f3-2a6e-4924-b228-e125c4ed91bc",
}

export enum SalesStatusEnum {
    UNVERIFIED = "4f067b18-2f94-4534-9d86-bf38f6008efb",
    CONVERTED = "17235406-e65d-44e7-87db-fdbc6ff47d09",
    NOT_CONVERTED = "9010501c-2543-45e4-8cde-aa0d757bd83a",
    ARCHIVE = "8a8b75a9-62e9-46d6-9d8a-d2fcde92d2ff",
}

export enum CallStatusEnum {
    SCHEDULED = "40ce358e-20b3-4dcf-8cc5-cffa33452017",
    CANCELLED = "632e2387-c9aa-4001-b658-51188a1a7c04",
    LOGGED = "2325a531-627f-49a5-936c-28e76476bda5",
    ARCHIVE = "a300b8f3-3f72-44fb-8cf6-f224457297aa",
}

export const lastEventTypes: Record<DhiraaguEventTypes, {
    id: Uuid,
    displayName: string
}> = {
    [DhiraaguEventTypes.enquiry]: {
        id: DhiraaguEventTypes.enquiry as Uuid,
        displayName: "Enquiry"
    },
    [DhiraaguEventTypes.call]: {
        id: DhiraaguEventTypes.call as Uuid,
        displayName: "Call"
    },
    [DhiraaguEventTypes.sale]: {
        id: DhiraaguEventTypes.sale as Uuid,
        displayName: "Sale"
    },
};

export const enquiryStatuses: Record<EnquiryStatusEnum, {
    id: Uuid,
    displayName: string
}> = {
    [EnquiryStatusEnum.NEW]: {
        id: EnquiryStatusEnum.NEW as Uuid,
        displayName: "New"
    },
    [EnquiryStatusEnum.DUPLICATE]: {
        id: EnquiryStatusEnum.DUPLICATE as Uuid,
        displayName: "Duplicate"
    },
    [EnquiryStatusEnum.RETURN]: {
        id: EnquiryStatusEnum.RETURN as Uuid,
        displayName: "Return"
    },
    [EnquiryStatusEnum.ARCHIVE]: {
        id: EnquiryStatusEnum.ARCHIVE as Uuid,
        displayName: "Archive"
    },
};

export const salesStatuses: Record<SalesStatusEnum, {
    id: Uuid,
    displayName: string
}> = {
    [SalesStatusEnum.UNVERIFIED]: {
        id: SalesStatusEnum.UNVERIFIED as Uuid,
        displayName: "Unverified"
    },
    [SalesStatusEnum.CONVERTED]: {
        id: SalesStatusEnum.CONVERTED as Uuid,
        displayName: "Converted"
    },
    [SalesStatusEnum.NOT_CONVERTED]: {
        id: SalesStatusEnum.NOT_CONVERTED as Uuid,
        displayName: "Not Converted"
    },
    [SalesStatusEnum.ARCHIVE]: {
        id: SalesStatusEnum.ARCHIVE as Uuid,
        displayName: "Archive"
    },
};

export const callStatuses: Record<CallStatusEnum, {
    id: Uuid,
    displayName: string
}> = {
    [CallStatusEnum.SCHEDULED]: {
        id: CallStatusEnum.SCHEDULED as Uuid,
        displayName: "Scheduled"
    },
    [CallStatusEnum.CANCELLED]: {
        id: CallStatusEnum.CANCELLED as Uuid,
        displayName: "Cancelled"
    },
    [CallStatusEnum.LOGGED]: {
        id: CallStatusEnum.LOGGED as Uuid,
        displayName: "Logged"
    },
    [CallStatusEnum.ARCHIVE]: {
        id: CallStatusEnum.ARCHIVE as Uuid,
        displayName: "Archive"
    },
};
